export default class Navigation {
	constructor(root) {
		this.root = root;

		this.topBar = root?.querySelector('.navigation-top-bar');

		this.mainSearch = root?.querySelector('.navigation-search');
		this.mainSearchCurtain = document.querySelector('.navigation-search-curtain');
		this.mainSearchOpenBtn = root?.querySelector('.navigation-search-open');
		this.mainSearchCloseBtn = root?.querySelector('.navigation-search-close');
		this.mainSearchSearchBar = root?.querySelector('.navigation-search input[type="search"]');

		this.offCanvas = document.querySelector('.off-canvas');
		this.offCanvasCurtain = document.querySelector('.off-canvas-curtain');
		this.offCanvasOpenBtn = root?.querySelector('.off-canvas-open');
		this.offCanvasCloseBtn = document.querySelector('.off-canvas-close');
		this.offCanvasSearchBar = this.offCanvas?.querySelector('input[type="search"]');
		this.offCanvasMenuLinks = this.offCanvas?.querySelectorAll('.off-canvas-menu-main .menu-item > a');
		this.offCanvasSubmenus = this.offCanvas?.querySelectorAll('.off-canvas-menu-main .menu-item .sub-menu');

		document.addEventListener('scroll', () => {
			if (scrollY > 100) {
				this.topBar.classList.add('collapsed');
			} else {
				this.topBar.classList.remove('collapsed');
			}
		});

		this.mainSearchOpenBtn?.addEventListener('click', () => {
			this.openSearchOverlay();
		});

		this.mainSearchCloseBtn?.addEventListener('click', () => {
			this.closeSearchOverlay();
		});

		this.mainSearchCurtain?.addEventListener('click', () => {
			this.closeSearchOverlay();
		});

		this.offCanvasOpenBtn?.addEventListener('click', () => {
			this.openMenu();
		});

		this.offCanvasCloseBtn?.addEventListener('click', () => {
			this.closeMenu();
		});

		this.offCanvasCurtain?.addEventListener('click', () => {
			this.closeMenu();
		});

		this.offCanvasMenuLinks?.forEach((link) => {
			link?.addEventListener('click', (e) => {
				const subMenu = link.parentElement.querySelector('.sub-menu');

				if (subMenu) {
					e.preventDefault();
					this.openSubMenu(link);
				}
			});
		});

		// Extend submenu's with back link and parent link
		this.offCanvasSubmenus?.forEach((menu) => {
			const _parentLink = menu.parentElement.querySelector('a');

			const parentLink = _parentLink.parentElement.cloneNode(true);
			parentLink.querySelector('.sub-menu')?.remove();
			parentLink.classList.remove('top-level');
			parentLink.classList.add('parent-link');

			const backLink = document.createElement('li');
			backLink.setAttribute('class', 'back');
			backLink.addEventListener('click', () => this.closeSubMenu(_parentLink));
			backLink.textContent = _parentLink?.textContent;

			const arrow = document.createElement('i');
			arrow.setAttribute('class', 'fa-light fa-arrow-left');

			backLink.prepend(arrow);
			menu.prepend(parentLink);
			menu.prepend(backLink);

			this.removeSubMenuTabIndexes(menu);
		});
	}

	addSubMenuTabIndexes(subMenu) {
		subMenu?.querySelectorAll('a').forEach((link) => {
			link.setAttribute('tabindex', '0');
		});
	}

	removeSubMenuTabIndexes(subMenu) {
		subMenu?.querySelectorAll('a').forEach((link) => {
			link.setAttribute('tabindex', '-1');
		});
	}

	openSubMenu(link) {
		const subMenu = link?.parentElement?.querySelector('.sub-menu');
		this.addSubMenuTabIndexes(subMenu);

		subMenu?.classList.add('active');
	}

	closeSubMenu(link) {
		const subMenu = link?.parentElement?.querySelector('.sub-menu');
		this.removeSubMenuTabIndexes(subMenu);

		subMenu?.classList.remove('active');
	}

	openMenu() {
		this.offCanvasCurtain?.classList.add('active');
		this.offCanvas?.classList.add('active');
		this.offCanvasSearchBar.focus();
	}

	closeMenu() {
		this.offCanvasCurtain?.classList.remove('active');
		this.offCanvas?.classList.remove('active');
		this.offCanvasSearchBar.value = '';
		this.offCanvasOpenBtn?.focus();

		// Wait until the transition on this.offCanvas is done,
		// then close all sub menus.
		let transitionDuration;
		try {
			transitionDuration =
				parseFloat(getComputedStyle(this.offCanvas)['transition-duration']?.replace('s', '') || '0.3') * 1000;
		} catch {
			transitionDuration = 300;
		}

		setTimeout(() => {
			this.offCanvasMenuLinks.forEach((link) => {
				this.closeSubMenu(link);
			});
		}, transitionDuration);
	}

	openSearchOverlay() {
		this.mainSearchCurtain?.classList.add('active');
		this.mainSearchOpenBtn.setAttribute('aria-expanded', 'true');
		this.mainSearch?.classList.add('active');
		this.mainSearchSearchBar.focus();
		this.mainSearch?.setAttribute('aria-hidden', 'false');
	}

	closeSearchOverlay() {
		this.mainSearchCurtain?.classList.remove('active');
		this.mainSearchOpenBtn.setAttribute('aria-expanded', 'false');
		this.mainSearch?.classList.remove('active');
		this.mainSearchSearchBar.value = '';
		this.mainSearch?.setAttribute('aria-hidden', 'true');
	}
}
